export default __webpack_public_path__ + "images/L3.27b6cba.png";